//changed due to package upgrade
import PropTypes from "prop-types";
import Navigation from "./Navigation";
import SimpleBar from "components/third-party/SimpleBar";

// ✅ make sure the new CSS import exists inside your SimpleBar wrapper file
// import "simplebar-react/dist/simplebar.min.css";

const DrawerContent = ({ handleDrawerToggle, isMobileView }) => (
  <SimpleBar
    style={{ height: "100%" }} // ✅ ensure scrollbar container has height
    sx={{
      "& .simplebar-content": {
        display: "flex",
        flexDirection: "column",
      },
    }}
  >
    <Navigation
      handleDrawerToggle={handleDrawerToggle}
      isMobileView={isMobileView}
    />
  </SimpleBar>
);

DrawerContent.propTypes = {
  handleDrawerToggle: PropTypes.func,
  isMobileView: PropTypes.bool,
};

export default DrawerContent;
